import { useState, useEffect, useCallback } from 'react'
import api from '../services/api'

/**
 * Hook para todo el flujo de fichaje grupal del manager.
 * - getMisGrupos: grupos donde soy manager (o todos si admin)
 * - getPreview(grupo_id, fecha): roster + estado fichaje del día
 * - submit({ grupo_id, fecha, tipo, hora_entrada, hora_salida, empleados_excluidos })
 */
export function useFichajeGrupal() {
  const [misGrupos, setMisGrupos] = useState([])
  // Empieza en `true` para que el componente pueda mostrar loading hasta el
  // primer fetch — evita el flash de "no eres manager" antes de cargar.
  const [cargando, setCargando] = useState(true)

  const refrescarMisGrupos = useCallback(async () => {
    setCargando(true)
    try {
      const r = await api.get('/fichajes/grupal/mis-grupos')
      setMisGrupos(r.data || [])
    } finally {
      setCargando(false)
    }
  }, [])

  useEffect(() => { refrescarMisGrupos() }, [refrescarMisGrupos])

  const getPreview = useCallback(async (grupo_id, fecha) => {
    const r = await api.get('/fichajes/grupal/preview', { params: { grupo_id, fecha } })
    return r.data
  }, [])

  const submit = useCallback(async (payload) => {
    const r = await api.post('/fichajes/grupal', payload)
    return r.data
  }, [])

  return { misGrupos, cargando, refrescarMisGrupos, getPreview, submit }
}
